<template>
  <div class="legend-border bg-white scroll-Container legend-scroll" :style="layerLegendMaxHeight">
    <b-row no-gutters>
      <b-col>
        <span id="modifiedLayerName" class="capitalize layer-name-header">
          {{ modifiedName }}
        </span>
        <fa id="closeLayerLegendElement" class="float-right clickable" title="Close Legend"
          :icon="['fas', 'window-close']" @click="$emit('closeLegend')" />
        <fa id="minOrMaxLayerLegendElement" class="float-right clickable mx-1"
          :title="legendMinimized ? 'Maximize Legend' : 'Minimize Legend'"
          :icon="['fas', legendMinimized ? 'window-maximize' : 'window-minimize']"
          @click="$emit(legendMinimized ? 'maximizeLegend' : 'minimizeLegend')" />
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col>
        <img id="imgLegend" v-show="!legendMinimized" :height="height" :width="width" :src="legendImgSrc"
          @load="getDimensions()" />
      </b-col>
    </b-row>
  </div>
</template>

<style scoped>
.layer-name-header {
  white-space: nowrap;
  margin: 12px;
}

.legend-scroll {
  overflow-y: auto;
}
</style>

<script>
export default {
  name: 'MMP_LayerLegend',
  props: [
    'layerLegendMaxHeight',
    'layerLegendName',
    'legendImgSrc',
    'legendMinimized'
  ],
  data() {
    return {
      height: 1,
      modifiedName: '',
      width: 1
    }
  },
  methods: {
    getDimensions() {
      let layerLegendImg = document.getElementById('imgLegend')
      let layerLegendModifiedName = document.getElementById('modifiedLayerName')
      let layerLegendClose = document.getElementById('closeLayerLegendElement')
      let layerLegendMinOrMax = document.getElementById('minOrMaxLayerLegendElement')
      let buttonsTotalWidth = layerLegendClose.clientWidth + layerLegendMinOrMax.clientWidth
      let nameWidth = layerLegendModifiedName.offsetWidth
      let totalHeaderWidth = nameWidth + buttonsTotalWidth + 40
      this.height = layerLegendImg.naturalHeight
      this.width = layerLegendImg.naturalWidth
      let aspectRatioWidthToUse =
        this.legendMinimized
          ? totalHeaderWidth
          : Math.max(totalHeaderWidth, this.width + buttonsTotalWidth)
      this.$emit('aspectRatio', {
        height: this.height,
        width: aspectRatioWidthToUse
      })
    },
    modifyNewLayerName(newLayerName) {
      return `${newLayerName.replace(/_/g, ' ')}`
    }
  },
  mounted() {
    this.modifiedName = this.modifyNewLayerName(this.layerLegendName)
    this.$emit('initResize')
  },
  watch: {
    layerLegendName: function (newValue, oldValue) {
      this.modifiedName = this.modifyNewLayerName(newValue)
      this.getDimensions()
    },
    legendMinimized: function (newValue, oldValue) {
      this.getDimensions()
    }
  }
}
</script>
